import React, { useRef, useEffect } from 'react';
import { avatarSizeTypes, avatarTypes } from './const';
import { getFontSize, getInitialsByName } from './utils';
import Icon from '../Icon';
import './Avatar.css';
import withTheme from '../../hocs/withTheme';

type AvatarProps = {
    shape?: 'circle' | 'square',
    iconType?: string | undefined,
    size?: number | 'large' | 'small' | 'default',
    src?: string,
    alt?: string,
    gap?: number,
    role?: string,
    onError?: () => void,
    withSecondName?: boolean,
    name?: string,
    className?: string,
    tabIndex?: number;
};

const Avatar = ({
    shape = 'circle',
    src = '',
    iconType = '',
    name = '',
    gap = 4,
    withSecondName = false,
    alt = '',
    size = 'default',
    className = '',
    onError = () => {},
    ...props
} : AvatarProps) => {
    const avatarSrc = src && 'avatar-image';
    const avatarType = avatarTypes[shape] || avatarTypes.circle;
    const avatarNodeRef = useRef<HTMLElement | null>(null);
    const avatarChildrenRef = useRef<HTMLElement | null>(null);


    const calcAvatarFontSize = (size) => {
        const defaultFontSize = getFontSize(avatarNodeRef?.current);

        if (size < defaultFontSize + (gap * 2) && avatarNodeRef?.current) {
            avatarNodeRef.current.style.fontSize = `${(defaultFontSize) - (gap * 2)}px`;
        }
    };

    const calculateSizeClass = () => {
        if (size in avatarSizeTypes) {
            return avatarSizeTypes[size].className;
        }


        return '';
    };

    const calculateSizeStyles = () => {
        if (size in avatarSizeTypes) {
            calcAvatarFontSize(avatarSizeTypes[size].px);
        } else if (typeof size === 'number' && size >= 0) {
            calcAvatarFontSize(size);

            if (avatarNodeRef?.current) {
                avatarNodeRef.current.style.width = `${size}px`;
                avatarNodeRef.current.style.height = `${size}px`;
                avatarNodeRef.current.style.lineHeight = `${size}px`;
            }

            if (avatarChildrenRef?.current) {
                avatarChildrenRef.current.style.lineHeight = `${size}px`;
            }
            
        }
    };


    const renderContent = () => {
        if (src) {
            return <img src={src} alt={alt} onError={onError} />;
        }
        if (iconType) {
            return <Icon type={iconType} />;
        }
        if (name) {
            return getInitialsByName(name, withSecondName);
        }

        return null;
    };

    useEffect(() => {
        calculateSizeStyles();
    }, []);

    return (
        <span
            ref={avatarNodeRef}
            className={`Avatar ${className} ${avatarType} ${avatarSrc} ${calculateSizeClass()}`}
            {...props}
        >
            <span ref={avatarChildrenRef} className="avatar-content">
                {renderContent()}
            </span>
        </span>
    );
};

export default withTheme(Avatar);
